import * as Moment from 'moment-timezone'

export class User {
  public id: number
  public name: string
  public email: string
  public phone: string
  public address: string
  public city: string
  public postal: string
  public sex: string
  public birthDate: any
  public picture: string
  public price: number
  public updated: boolean
  public participating: boolean
  public campaigns: any[]
  public categories: any[]
  public mediaType: string
  public followers: number
  public userName: string

  public instagramFollowers: number;
  public instagram: string
  public facebookFollowers: number;
  public facebook: string
  public youtubeFollowers: number;
  public youtube: string

  public avgLikes: number
  public avgComments: number
  public maleFollowers: number
  public ghostFollowers: number
  public israeliFollowers: number
  public teenagersFollowers: number
  public studentFollowers: number
  public youngFollowers: number
  public adultFollowers: number
  public oldFollowers: number

  constructor(user:any = {}) {
    this.id = user.id || null
    this.name = user.name || ""
    this.email = user.email || ""
    this.phone = user.phone || ""
    this.picture = user.picture || ""
    this.address = user.address || ""
    this.city = user.city || ""
    this.postal = user.postal || ""
    this.sex = user.sex || ""
    this.birthDate = user.birthDate? Moment(user.birthDate) : null
    this.participating = user.participating || false
    this.mediaType = user.mediaType || "facebook"
    this.updated = true
    this.price = user.price || null
    this.campaigns = user.campaigns || []
    this.categories = user.categories || []
    this.instagram = user.instagram || ""
    this.instagramFollowers = user.instagramFollowers || null
    this.facebook = user.facebook || ""
    this.facebookFollowers = user.facebookFollowers || null
    this.youtube = user.youtube || ""
    this.youtubeFollowers = user.youtubeFollowers || null
    this.avgLikes = user.avgLikes || 0
    this.avgComments = user.avgComments || 0
    this.maleFollowers = user.maleFollowers || 0
    this.ghostFollowers = user.ghostFollowers || 0
    this.israeliFollowers = user.israeliFollowers || 0
    this.teenagersFollowers = user.teenagersFollowers || 0
    this.studentFollowers = user.studentFollowers || 0
    this.youngFollowers = user.youngFollowers || 0
    this.adultFollowers = user.adultFollowers || 0
    this.oldFollowers = user.oldFollowers || 0
  }
}



// WEBPACK FOOTER //
// ./src/_models/User.tsx